export const DEFAULT_ABOUT_DETAILS_SUBTITLE =
  "Visit the first digital conference.";
export const DEFAULT_ABOUT_DETAILS_DESCRIPTION =
  "FOODPhilippines is a branding initiative of the Center for International Trade Expositions & Missions (CITEM) that enforces the image of the Philippines as a top source of quality food products derived from fresh, healthy, and natural ingredients.";
export const DEFAULT_ABOUT_DETAILS_LIST_ITEM_1 =
  "10 technologies that will transform the global economy by 2025";
export const DEFAULT_ABOUT_DETAILS_LIST_ITEM_2 =
  "The key to surviving this new industrial revolution is leading it. That requires two key elements of agile businesses.";
export const DEFAULT_ABOUT_DETAILS_LIST_ITEM_3 =
  "Learn what it takes to hire and inspire your talent with an employee-centric organizational model. Get our free guide: 5 keys to successful organizational design";
export const DEFAULT_ABOUT_DETAILS_LIST_ITEM_4 =
  "Earth is the third planet from the Sun and the only astronomical object known to harbor life.";
export const DEFAULT_ABOUT_DETAILS_CTA_TEXT = "Buy tickets";
